<template>
<button
  type="button"
  v-if="$can('user.inactivate') && !loading"
  class="btn btn-danger btn-fill btn-icon"
  title="Desativar"
  @click="handleInactivate()"
>
  <i class="ti-unlink"></i>
</button>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import sweetalert from 'sweetalert2'

export default {
  name: 'inactivate-user-action',

  props: {
    user: {}
  },

  computed: {
    ...mapGetters('users', {
      loading: 'loading'
    })
  },

  methods: {
    ...mapActions('users', ['upsert']),

    handleInactivate () {
      sweetalert({
        text: 'Deseja destivar ' + this.user.name + '?',
        title: 'Atenção',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        type: 'warning'
      })
        .then(() => {
          this.upsert(Object.assign(this.user, { inactivate: true }))
            .then(() => {
              sweetalert('Desativado!', 'Usuário desativado com sucesso', 'success')
              this.$emit('fetch')
            })
        })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Users/InactivateUserAction.vue